import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {WeChatApplicationDto} from "../dto/WeChatApplicationDto";

export const WeChatApplicationApi = {

    getWeChatApplicationList: async () => {
        try {
            const requestUrl = '/v1/wechat/application/list';
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getWeChatApplicationDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/wechat/application/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createWeChatApplication: async (body: WeChatApplicationDto) => {
        try {
            const requestUrl = '/v1/wechat/application/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateWeChatApplication: async (body: WeChatApplicationDto) => {
        try {
            const requestUrl = '/v1/wechat/application/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteWeChatApplication: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/wechat/application/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
